const formatter = (quantity, currency) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency }).format(quantity);

export default formatter;

export function padWithZeroes(number, length) {
  let myString = `${number}`;
  while (myString.length < length) {
    myString = `0${myString}`;
  }

  return myString;
}
